"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailPayloadTemplate = void 0;
var email_payload_template_1 = require("./email-payload-template");
Object.defineProperty(exports, "EmailPayloadTemplate", { enumerable: true, get: function () { return email_payload_template_1.EmailPayloadTemplate; } });
